import React from 'react'
import ReactDOM from 'react-dom/client'
import { AppContainer } from './App'
import './index.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import 'react-toastify/dist/ReactToastify.css'
import { ThemeProvider } from '@mui/material'
import { ToastContainer } from 'react-toastify'
import { store } from './state/store'
import { Provider } from 'react-redux'
import relay from './relay'
import { RelayEnvironmentProvider } from 'react-relay/hooks'
import reportWebVitals from './reportWebVitals'
import ErrorView from './components/ErrorView'
import { theme } from './mui'
import ErrorBoundary from './components/ErrorBoundary'
import { Auth0Provider } from '@auth0/auth0-react'
import { LicenseInfo } from '@mui/x-license'
import { analytics } from './analytics/segment'

// MUI X Pro license (DataGridPro detail panels in the admin panel).
if (process.env.REACT_APP_MUI_X_LICENSE_KEY) {
  LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_X_LICENSE_KEY)
}

if (process.env.REACT_APP_DEVELOPMENT_MODE === 'true') {
  analytics.debug(true)
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Auth0Provider
      domain="dev-holrg1k8ni3w3s1b.us.auth0.com"
      clientId="RWqAz5oFCZXnsPz1GV2EbVXtjLlxDvX2"
      redirectUri={window.location.origin}
    >
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <RelayEnvironmentProvider environment={relay}>
            <ErrorBoundary errorView={<ErrorView />}>
              <ToastContainer />
              <AppContainer />
            </ErrorBoundary>
          </RelayEnvironmentProvider>
        </ThemeProvider>
      </Provider>
    </Auth0Provider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
